import React from 'react';
import Style from '../../components/Spinner/style.scss';
import Cx from 'classnames';
class Spinner extends React.Component {

    constructor(...args) {
        super(...args);
    }

    render() {
            return (
                <div id='loaderWrapper'>
                    <div className={Cx(Style.modalBackdrop, Style.in)}></div>
                    <div className={Style.preloader}>
                        <div className={Style.innerIcon}></div>
                        <div className={Style.spinner}></div>
                    </div>
                </div>
            )
    }
}
export default Spinner;






// WEBPACK FOOTER //
// ./components/Spinner/index.js